import { useMemo } from 'react'
import { Chip } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { getRoleColor, getRoleLabel } from '../utils/helpers/roles.helpers'

interface RoleChipProps {
  role: number | string
  testId?: string
}

const RoleChip: React.FC<RoleChipProps> = ({ role, testId }) => {
  const chipColor = useMemo(() => getRoleColor(role), [role])

  const roleLabel = useMemo(() => getRoleLabel(role), [role])

  return <Chip color={chipColor as colors} size="sm" value={roleLabel} data-testid={testId} /> // eslint-disable-line @typescript-eslint/no-explicit-any
}

export default RoleChip
